import React from 'react';
import { Box, OSKIcon, OSKThemeType, Typography } from 'oskcomponents';
import { useTheme } from 'styled-components';

export type PurchasedChipProps = {
    /** The optional text to display next to the icon.*/
    value?: string;
};

export const PurchasedChip = ({ value, ...props }: PurchasedChipProps) => {
    const theme = useTheme() as OSKThemeType;

    return (
        <Box
            {...props}
            style={{
                borderRadius: '4px',
                width: 'fit-content',
                height: '23px',
                padding: '0px 6px',
                backgroundColor: theme.colors.green800a,
            }}
            center="all"
        >
            <OSKIcon
                code="shopping-bag"
                fill={theme.colors.green800}
                scale={90}
                style={{
                    top: '-1px',
                    position: 'relative',
                }}
            />
            {value !== undefined && value !== null && (
                <>
                    <Typography
                        variant="caption1"
                        color={theme.colors.green800}
                        style={{
                            fontWeight: '700',
                            paddingLeft: '4px',
                            paddingRight: '2px',

                            top: '-1px',
                            position: 'relative',
                        }}
                    >
                        {value}
                    </Typography>
                </>
            )}
        </Box>
    );
};
